module.exports = __webpack_public_path__ + "static/media/vidal6.f46ada56.png";